import { QUESTION_TYPE_DEFINITIONS, type QuestionType } from 'inspection-types';

export type QuestionTypeIcon =
  | 'rating'
  | 'choice'
  | 'checklist'
  | 'text'
  | 'numeric'
  | 'date'
  | 'list'
  | 'observation'
  | 'unknown';

export type QuestionTypeDisplay =
  | { kind: 'pointScale'; points: number; icon: 'rating' }
  | { kind: 'named'; displayName: string; icon: QuestionTypeIcon };

const POINT_SCALE_BY_QUESTION_TYPE: Partial<Record<QuestionType, number>> = {
  rating_3_point: 3,
  rating_5_point: 5,
};

const ICON_BY_QUESTION_TYPE: Record<QuestionType, QuestionTypeIcon> = {
  rating_5_point: 'rating',
  rating_3_point: 'rating',
  pass_fail: 'choice',
  ok_deficient: 'choice',
  yes_no: 'choice',
  condition_action: 'choice',
  checklist: 'checklist',
  text_only: 'text',
  numeric: 'numeric',
  date: 'date',
  select: 'list',
  multi_select: 'list',
  observation: 'observation',
};

function isKnownQuestionType(
  questionType: string
): questionType is QuestionType {
  return Object.hasOwn(QUESTION_TYPE_DEFINITIONS, questionType);
}

// Accepts any string: a newer server can send a type this client does not know yet
export function getQuestionTypeDisplay(
  questionType: string
): QuestionTypeDisplay {
  if (!isKnownQuestionType(questionType)) {
    return { kind: 'named', displayName: questionType, icon: 'unknown' };
  }

  const points = POINT_SCALE_BY_QUESTION_TYPE[questionType];

  if (points !== undefined) {
    return { kind: 'pointScale', points, icon: 'rating' };
  }

  return {
    kind: 'named',
    displayName: QUESTION_TYPE_DEFINITIONS[questionType].displayName,
    icon: ICON_BY_QUESTION_TYPE[questionType],
  };
}
